import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarContacto } from '../../actions/asesorias';

const EliminarContacto = ({ contacto, reestablecerContacto }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar contacto */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarContacto({
            id_asesoria: contacto?.id_asesoria, 
            id_contacto: contacto?.id_contacto
        }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerContacto(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(contacto != null){
            setEliminarModal(true);
        }
    }, [contacto]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar contacto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el contacto de {contacto?.fecha} del historial?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarContacto;